import { notification } from "antd";
import React, { useEffect, useState } from "react";
import { baseUrl, revert } from "../dasboard";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import dayjs from "dayjs";

import {
  getUserInfo,
  handleError,
  saveTableInfo,
  saveUserInfo,
  saveToken,
  saveStreamToken,
  saveStreamInfo,
  clearAuth,
  saveLocale,
} from "../../hooks/useHttp";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { usersAction } from "../../store";
import { StreamApiClient } from "../../services/streamService";

import QrReader from "react-qr-scanner";
import {
  AuthScreen,
  FooterCredit,
  GoogleLoginButton,
  LanguageButton,
  LoginPanel,
  MenuActionCard,
  MenuActionGrid,
  PasswordInput,
  PixelButton,
  PixelDivider,
  PixelField,
  PixelHeading,
  PixelInput,
  PixelModal,
  PixelModalActions,
  PixelToggle,
  ScreenFrame,
  SignupPrompt,
} from "../../design/retro";
import tableIcon from "../../assets/retro/table-icon.png";
import qrIcon from "../../assets/retro/qr-icon.png";
const formatTime = (timestamp) => {
  return dayjs(timestamp).format("HH:mm:ss, DD/MM/YYYY");
};


function LoginPage() {

  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [inputTableId, setInputTableId] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const locale = useSelector((state) => state.users.locale);
  const dispatch = useDispatch();
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
  const [openQr, setOpenQr] = useState(false);
  const [isHttps, setIsHttps] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [createTableModalOpen, setCreateTableModalOpen] = useState(false);
  const [withChicken, setWithChicken] = useState(false);
  const [customTableName, setCustomTableName] = useState("");
  const [streamQrOpen, setStreamQrOpen] = useState(false);
  const [, setStreamIsLive] = useState(false);
  const [streamLoading, setStreamLoading] = useState(false);
  const [editUsernameModalOpen, setEditUsernameModalOpen] = useState(false);
  const [newUsername, setNewUsername] = useState("");
  const [editUsernameLoading, setEditUsernameLoading] = useState(false);
  //test scanner area react-qr-scanner////
  useEffect(() => {
    const currentLocation = window.location.href;

    // setIsHttps(currentLocation.split(":")[0] === "https" ? true : false);
// console.log("currentLocation", currentLocation.split(":")[1]);
    if (currentLocation.split(":")[0] === "https" ) {
      setIsHttps(true);
    }
    if (currentLocation.split(":")[0] === "http") {
      if (currentLocation.split(":")[1] === "//localhost") {
        setIsHttps(true);
      } else {
        setIsHttps(false);
      }
    }
  }, []);

  const delay = 300;

  const previewStyle = { width: "100%", height: "100%" };

  const getTableIdFromQrText = (text) => {
    const rawText = text?.trim();
    if (!rawText) return "";

    try {
      const qrUrl = new URL(rawText, window.location.origin);
      const pathParts = qrUrl.pathname.split("/").filter(Boolean);
      return pathParts[pathParts.length - 1] || "";
    } catch (error) {
      const pathParts = rawText.split(/[/?#]/).filter(Boolean);
      return pathParts[pathParts.length - 1] || "";
    }
  };

  const handlerScanWebcam = async (result) => {
    if (result) {
      setOpenQr(false);

      const qrTableId = getTableIdFromQrText(result?.text);
      if (!qrTableId) {
        notification.error({
          message: formatMessage({ id: "error.invalidQrCode" }),
          placement: "top",
        });
        return;
      }

      await joinTableHandler(qrTableId);
    }
  };

  const handlerScanCodeError = (err) => {
    console.log("err", err);
    navigate("/");
  };

  // Stream QR scan handler - checks for existing stream or creates new one
  const handleStreamQrScan = async (result) => {
    if (result) {
      setStreamQrOpen(false);
      const qrTableId = getTableIdFromQrText(result?.text);
      if (!qrTableId) {
        notification.error({
          message: formatMessage({ id: "error.invalidQrCode" }),
          placement: "top",
        });
        return;
      }
      
      setStreamLoading(true);
      try {
        const apiClient = new StreamApiClient();
        let streamId = null;
        
        // Step 1: Check if table already has a stream_id
        try {
          const tableResponse = await fetch(`${baseUrl}/tables/${qrTableId}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          if (tableResponse.ok) {
            const tableData = await tableResponse.json();
            if (tableData.streamId) {
              streamId = tableData.streamId;
              console.log('[Login] Found existing stream_id:', streamId);
            }
          }
        } catch (e) {
          console.log('[Login] Could not fetch table, will create new stream');
        }
        
        // Step 2: If no existing stream, create new one
        if (!streamId) {
          const createResponse = await apiClient.createStream(qrTableId);
          streamId = createResponse.stream_id;
          console.log('[Login] Created new stream:', streamId);
          
          // Save stream_id to backend
          try {
            await fetch(`${baseUrl}/tables/${qrTableId}/stream-id`, {
              method: 'PUT',
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}` 
              },
              body: JSON.stringify({ streamId: streamId })
            });
            console.log('[Login] Saved stream_id to backend');
          } catch (e) {
            console.warn('[Login] Could not save stream_id to backend:', e);
          }
        }
        
        // Step 3: Activate stream (set is_live = true)
        const activateResponse = await apiClient.activateStream(streamId);
        console.log('[Login] Stream activated:', activateResponse);
        
        // Check if is_live is true
        if (activateResponse.is_live === true) {
          setStreamIsLive(true);
          notification.success({
            message: 'Stream Activated',
            description: 'Stream is now live!',
            placement: 'top',
          });
          
          // Navigate to broadcast page with stream info
          navigate(`/stream/broadcast/${qrTableId}`, {
            state: { 
              streamId: streamId,
              isLive: true 
            }
          });
        } else {
          notification.warning({
            message: 'Stream Not Live',
            description: 'Stream was created but not activated.',
            placement: 'top',
          });
        }
      } catch (error) {
        console.error('[Login] Failed to create/activate stream:', error);
        notification.error({
          message: 'Stream Failed',
          description: error.message,
          placement: 'top',
        });
      } finally {
        setStreamLoading(false);
      }
    }
  };
  ///////////////end test area//////////////////

  useEffect(() => {
    const currentuser = getUserInfo();
    console.log("--------------- currentuser -----------------", currentuser);
    if (currentuser) {
      setIsLoggedIn(true);
      setUserName(currentuser.username);
    }
  }, []);

  const onUserEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const onUserNameChange = (e) => {
    setUserName(e.target.value);
  };

  const onPasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const onConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const joinTableHandler = async (tableId) => {
    if (!tableId) {
      notification.error({
        message: formatMessage({ id: "error.invalidQrCode" }),
        placement: "top",
      });
      return;
    }

    const currentUser = getUserInfo();
    const token = localStorage.getItem("token");

    if (!currentUser?.id || !token) {
      localStorage.setItem("pendingTableId", tableId);
      notification.info({
        message: "Please log in to join a table",
        placement: "top",
      });
      return;
    }

    try {
      setIsLoading(true);
      const res = await fetch(
        `${baseUrl}/tables/${tableId}/players`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId: currentUser.id }),
        }
      );

      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        saveTableInfo(tableId);
        navigate(`/${tableId}`);
        return;
      }

      notification.error({
        message: data.error || data.message || "Failed to join table",
        placement: "top",
      });
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const openCreateTableModal = () => {
    const date = Date.now();
    const defaultTableName = `${userName}'s Table ${date}`;
    setCustomTableName(defaultTableName);
    setWithChicken(false); // Reset về false mỗi lần mở modal
    setCreateTableModalOpen(true);
  };

  const onCreateTable = async () => {
    try {
      setCreateTableModalOpen(false);
      setIsLoading(true);
      
      // Sử dụng tên bàn tùy chỉnh hoặc tạo một tên mặc định nếu rỗng
      const tableName = customTableName || `${userName}'s Table ${Date.now()}`;
      

      let createTableUrl = withChicken 
        ? `${baseUrl}/tables/with-chicken` 
        : `${baseUrl}/tables`;
     
      const res = await fetch(createTableUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ tableName: tableName }),
      });
      
      if (res.status === 201) {
        const data = await res.json();
        if (data && data.id) {
          // Mark as table creator to avoid joining the table again
          localStorage.setItem("isTableCreator", "true");
          // Save the table ID and navigate directly to the table
          saveTableInfo(data.id);
          navigate(`/${data.id}`);
        }
      } else {
        const data = await res.json();
        notification.error({
          message: data.error || "Failed to create table",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const registerHandler = async () => {
    if (password !== confirmPassword) {
      notification.error({
        message: "Passwords do not match",
        placement: "top",
      });
      return;
    }

    try {
      setIsLoading(true);
      const res = await fetch(`${baseUrl}/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          username: userName,
          password: password,
        }),
      });

      const data = await res.json();

      if (res.status === 201) {
        notification.success({
          message: "Registration successful. You can now log in.",
          placement: "top",
        });
        setIsRegisterView(false); // Switch to login view
      } else {
        notification.error({
          message: data.error || "Registration failed",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const applyLoginResponse = async (data) => {
    saveToken(data.token);
    if (data.streamToken) {
      saveStreamToken(data.streamToken);
      saveStreamInfo({ app_name: data.app_name });
    }
    const userInfo = {
      username: data.user.username,
      id: data.user.id,
    };
    saveUserInfo(userInfo);
    setUserName(data.user.username);
    setIsLoggedIn(true);
    notification.success({
      message: "Login successful",
      placement: "top",
    });

    const pendingTableId = localStorage.getItem("pendingTableId");
    if (pendingTableId) {
      localStorage.removeItem("pendingTableId");
      try {
        await joinTableHandler(pendingTableId);
      } catch (error) {
        console.error("Failed to auto-join table:", error);
      }
    }
  };

  const loginHandler = async () => {
    try {
      setIsLoading(true);
      const res = await fetch(`${baseUrl}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          username: userName,
          password: password,
        }),
      });

      const data = await res.json();

      if (res.status === 200 && data.token) {
        await applyLoginResponse(data);
      } else {
        notification.error({
          message: data.error || "Login failed",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const googleLoginHandler = async (credentialResponse) => {
    if (!credentialResponse?.credential) {
      notification.error({
        message: "Google login failed",
        placement: "top",
      });
      return;
    }

    try {
      setIsLoading(true);
      const res = await fetch(`${baseUrl}/auth/google`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ credential: credentialResponse.credential }),
      });

      const data = await res.json();

      if (res.status === 200 && data.token) {
        await applyLoginResponse(data);
      } else {
        notification.error({
          message: data.error || "Google login failed",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const logoutHandler = () => {
    setIsLoggedIn(false);
    setUserName("");
    clearAuth();
  };

  const updateUsernameHandler = async () => {
    if (!newUsername.trim()) return;
    try {
      setEditUsernameLoading(true);
      const res = await fetch(`${baseUrl}/auth/username`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ username: newUsername.trim() }),
      });
      const data = await res.json();
      if (res.ok) {
        setUserName(data.username);
        const userInfo = getUserInfo();
        saveUserInfo({ ...userInfo, username: data.username });
        setEditUsernameModalOpen(false);
        notification.success({
          message: formatMessage({ id: "auth.usernameUpdated" }),
          placement: "top",
        });
      } else {
        notification.error({
          message: data.error || "Failed to update username",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setEditUsernameLoading(false);
    }
  };
  
  // Hàm lấy lịch sử các bàn đã tham gia
  const fetchPlayHistory = async () => {
    try {
      setHistoryLoading(true);
      const currentUser = getUserInfo();
      if (!currentUser || !currentUser.id) {
        notification.error({
          message: `${formatMessage({ id: "error.fetchUserData" })}`,
          placement: "top",
        });
        return;
      }
      
      const res = await fetch(`${baseUrl}/players/${currentUser.id}/history`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
        },
      });
      
      const data = await res.json();
      
      if (res.ok) {
        revert(data);
        setHistoryData(data);
        setHistoryModalOpen(true);
      } else {
        notification.error({
          message: data.error || `${formatMessage({ id: "error.fetchPlayerHistoryData" })}`,
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setHistoryLoading(false);
    }
  };

  const [isRegisterView, setIsRegisterView] = useState(false);
  const t = (id, values) => formatMessage({ id }, values);

  const toggleLanguage = () => {
    const next = locale === "vi_VN" ? "en_US" : "vi_VN";
    dispatch(usersAction.setLocale(next));
    saveLocale(next);
  };

  const submitAuth = (event) => {
    event.preventDefault();
    if (isRegisterView) registerHandler();
    else loginHandler();
  };

  const authDisabled = isRegisterView
    ? !email || !userName || !password || !confirmPassword || isLoading
    : !email || !password || isLoading;

  return (
    <>
      {!isLoggedIn && (
        <AuthScreen
          locale={locale}
          onToggleLanguage={toggleLanguage}
          heading={t("auth.hero")}
          subtitle={t("auth.heroSubtitle")}
          footer="bip.ermis.network"
        >
          <LoginPanel
            title={t(isRegisterView ? "auth.registerTitle" : "auth.welcomeTitle")}
            subtitle={t(isRegisterView ? "auth.registerSubtitle" : "auth.loginSubtitle")}
            prompt={
              isRegisterView ? (
                <SignupPrompt
                  text={t("auth.haveAccount")}
                  actionText={t("auth.signIn")}
                  onAction={() => setIsRegisterView(false)}
                />
              ) : (
                <SignupPrompt
                  text={t("auth.noAccount")}
                  actionText={t("auth.signUp")}
                  onAction={() => setIsRegisterView(true)}
                />
              )
            }
          >
            <form className="rt-form-stack" onSubmit={submitAuth} noValidate>
              <PixelInput
                type="email"
                inputMode="email"
                autoComplete="email"
                autoCapitalize="none"
                value={email}
                onChange={onUserEmailChange}
                placeholder={t("placeHolder.enterEmail")}
                aria-label={t("auth.email")}
              />
              {isRegisterView && (
                <PixelInput
                  type="text"
                  autoComplete="nickname"
                  value={userName}
                  onChange={onUserNameChange}
                  placeholder={t("placeHolder.enterName")}
                  aria-label={t("auth.username")}
                />
              )}
              <PasswordInput
                value={password}
                onChange={onPasswordChange}
                autoComplete={isRegisterView ? "new-password" : "current-password"}
                placeholder={t("placeHolder.enterPassword")}
                aria-label={t("auth.password")}
                showLabel={t("ui.showPassword")}
              />
              {isRegisterView && (
                <PasswordInput
                  value={confirmPassword}
                  onChange={onConfirmPasswordChange}
                  autoComplete="new-password"
                  placeholder={t("placeHolder.confirmPassword")}
                  aria-label={t("auth.confirmPassword")}
                  showLabel={t("ui.showPassword")}
                />
              )}
              <PixelButton type="submit" variant="primary" size="lg" block disabled={authDisabled}>
                {isLoading ? t("ui.loading") : t(isRegisterView ? "title.register" : "title.login")}
              </PixelButton>
            </form>
            {!isRegisterView && googleClientId && (
              <>
                <PixelDivider label={t("message.or")} />
                <GoogleLoginButton>
                  <GoogleLogin
                    onSuccess={googleLoginHandler}
                    onError={() => notification.error({ message: "Google login failed", placement: "top" })}
                    theme="outline"
                    shape="rectangular"
                    text="continue_with"
                    width="320"
                  />
                </GoogleLoginButton>
              </>
            )}
          </LoginPanel>
        </AuthScreen>
      )}

      {isLoggedIn && (
        <ScreenFrame className="rt-home-screen">
          <header className="rt-home-header">
            <div className="rt-topbar">
              <p className="rt-brand">BIP SCORE</p>
              <div className="rt-home-tools">
                <PixelButton
                  variant="paper"
                  size="sm"
                  onClick={() => {
                    setNewUsername(userName);
                    setEditUsernameModalOpen(true);
                  }}
                >
                  {t("home.editName")}
                </PixelButton>
                <LanguageButton locale={locale} onToggle={toggleLanguage} />
              </div>
            </div>
            <PixelHeading className="rt-home-title">{t("home.hello", { name: userName })}</PixelHeading>
          </header>

          <div className="rt-home-body">
            <MenuActionGrid>
              <MenuActionCard
                title={t("button.createTable")}
                iconSrc={tableIcon}
                onClick={openCreateTableModal}
                disabled={isLoading}
              />
              <MenuActionCard
                title={t("button.scanQrCode")}
                iconSrc={qrIcon}
                disabled={!isHttps}
                onClick={() => setOpenQr(true)}
              />
            </MenuActionGrid>

            <form
              onSubmit={(event) => {
                event.preventDefault();
                if (inputTableId.trim()) joinTableHandler(inputTableId.trim());
              }}
            >
              <p className="rt-section-label">{t("home.orEnterId")}</p>
              <div className="rt-join-row">
                <PixelInput
                  type="text"
                  autoCapitalize="none"
                  autoCorrect="off"
                  enterKeyHint="go"
                  placeholder={t("placeHolder.enterTableId")}
                  aria-label={t("placeHolder.enterTableId")}
                  value={inputTableId}
                  onChange={(e) => setInputTableId(e.target.value)}
                />
                <PixelButton type="submit" variant="primary" disabled={!inputTableId.trim() || isLoading}>
                  {t("button.joinTable")}
                </PixelButton>
              </div>
            </form>

            <div className="rt-two-col">
              <PixelButton variant="paper" onClick={fetchPlayHistory} disabled={historyLoading}>
                {historyLoading ? t("ui.loading") : t("home.joinedTables")}
              </PixelButton>
              <PixelButton
                variant="blue"
                onClick={() => isHttps && setStreamQrOpen(true)}
                disabled={!isHttps || streamLoading}
              >
                {streamLoading ? t("ui.loading") : t("home.goLive")}
              </PixelButton>
            </div>
            {!isHttps && <p className="rt-text rt-text-muted rt-scanner-hint">{t("home.scanNeedsHttps")}</p>}
          </div>

          <footer className="rt-home-footer">
            <PixelButton variant="ghost" size="sm" onClick={logoutHandler}>
              {t("title.logout")}
            </PixelButton>
            <FooterCredit>From Hoangbim with ♥</FooterCredit>
          </footer>
        </ScreenFrame>
      )}

      {/* Quét QR để vào bàn / để phát live: mở toàn màn hình */}
      <PixelModal
        open={openQr || streamQrOpen}
        onClose={() => {
          setOpenQr(false);
          setStreamQrOpen(false);
        }}
        title={t(streamQrOpen ? "home.scanLiveTitle" : "home.scanTitle")}
        closeLabel={t("ui.close")}
      >
        <div className="rt-scanner">
          <div className="rt-scanner-video">
            {(openQr || streamQrOpen) && (
              <QrReader
                delay={delay}
                style={previewStyle}
                onError={handlerScanCodeError}
                onScan={streamQrOpen ? handleStreamQrScan : handlerScanWebcam}
                constraints={{
                  audio: false,
                  video: { facingMode: "environment" },
                }}
              />
            )}
          </div>
          <p className="rt-text rt-scanner-hint">{t("home.scanHint")}</p>
        </div>
      </PixelModal>

      {/* Lịch sử bàn đã tham gia */}
      <PixelModal
        open={historyModalOpen}
        onClose={() => setHistoryModalOpen(false)}
        size="full"
        title={t("history.title")}
        closeLabel={t("ui.close")}
      >
        {historyLoading ? (
          <p className="rt-empty">{t("ui.loading")}</p>
        ) : historyData.length === 0 ? (
          <p className="rt-empty">{t("message.notJoined")}</p>
        ) : (
          <div className="rt-card-list">
            {[...historyData].reverse().map((item) => (
              <button
                type="button"
                key={item.tableId}
                className="rt-card"
                onClick={() => {
                  saveTableInfo(item.tableId);
                  navigate(`/${item.tableId}`);
                  setHistoryModalOpen(false);
                }}
              >
                <span className="rt-card-row">
                  <span className="rt-card-title">{item.tableName}</span>
                  <span className={`rt-card-amount ${item.currentPoints > 0 ? "rt-amount-in" : "rt-amount-out"}`}>
                    {item.currentPoints}
                  </span>
                </span>
                <span className="rt-card-row">
                  <span className="rt-card-meta">
                    {t("message.joinedAt")}: {formatTime(item.joinedAt)}
                  </span>
                  {item.isCreator && <span className="rt-badge">{t("history.creator")}</span>}
                </span>
              </button>
            ))}
          </div>
        )}
      </PixelModal>

      {/* Đổi tên */}
      <PixelModal
        open={editUsernameModalOpen}
        onClose={() => setEditUsernameModalOpen(false)}
        title={t("auth.updateUsername")}
        closeLabel={t("ui.close")}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            updateUsernameHandler();
          }}
        >
          <PixelField label={t("auth.newUsername")}>
            <PixelInput
              type="text"
              value={newUsername}
              onChange={(e) => setNewUsername(e.target.value)}
              maxLength={50}
              autoFocus
            />
          </PixelField>
          <PixelModalActions>
            <PixelButton variant="paper" onClick={() => setEditUsernameModalOpen(false)}>
              {t("button.cancel")}
            </PixelButton>
            <PixelButton type="submit" variant="primary" disabled={editUsernameLoading || !newUsername.trim()}>
              {editUsernameLoading ? t("table.saving") : t("auth.updateUsername")}
            </PixelButton>
          </PixelModalActions>
        </form>
      </PixelModal>

      {/* Tạo bàn mới */}
      <PixelModal
        open={createTableModalOpen}
        onClose={() => setCreateTableModalOpen(false)}
        title={t("table.createTitle")}
        closeLabel={t("ui.close")}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            onCreateTable();
          }}
        >
          <PixelField label={t("title.tableName")} help={t("title.tableHelp")}>
            <PixelInput
              type="text"
              value={customTableName}
              onChange={(e) => setCustomTableName(e.target.value)}
            />
          </PixelField>

          <div className="rt-toggle-row">
            <span>{t("button.create-chick")}</span>
            <PixelToggle
              checked={withChicken}
              onChange={(checked) => setWithChicken(checked)}
              label={t("button.create-chick")}
            />
          </div>

          <PixelModalActions>
            <PixelButton variant="paper" onClick={() => setCreateTableModalOpen(false)}>
              {t("button.cancel")}
            </PixelButton>
            <PixelButton type="submit" variant="primary" disabled={isLoading}>
              {isLoading ? t("table.creating") : t("button.create")}
            </PixelButton>
          </PixelModalActions>
        </form>
      </PixelModal>
    </>
  );
}

export default LoginPage;
